import React, { useEffect, useState } from "react";
import { AddStaffAPI } from "../../../utils/APIs/staffsApis";
import { getRolesAPI } from "../../../utils/APIs/RoleApis";
import { toast } from "react-toastify";
import "./AddStaffModal.css";
import { FiEye, FiEyeOff } from "react-icons/fi";


const AddStaffModal = ({ isOpen, onClose, refreshData }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    roleId: "",
  });

  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Fetch roles when modal opens
  useEffect(() => {
    if (isOpen) {
      fetchRoles();
    }
  }, [isOpen]);

  const fetchRoles = async () => {
    try {
      const res = await getRolesAPI(1, 100);
      setRoles(res?.data?.data || []);
    } catch {
      toast.error("Failed to load roles");
    }
  };

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.password || !form.roleId) {
      toast.error("All fields are required");
      return;
    }

    try {
      setLoading(true);
      const res = await AddStaffAPI(form);

      if (res?.data?.success) {
        toast.success("Staff added successfully");
        refreshData();
        onClose();
        setForm({
          name: "",
          email: "",
          password: "",
          roleId: "",
        });
      } else {
        toast.error(res?.data?.message || "Failed to add staff");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>Add Staff</h3>

        <input
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
        />

        <input
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
        />

        <div className="password-wrapper">
          <input
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
          />

          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
          </span>
        </div>

        {/* Role Dropdown */}
        <select
          name="roleId"
          value={form.roleId}
          onChange={handleChange}
          className="custom-select"
        >
          <option value="">Select Role</option>
          {roles.map((role) => (
            <option key={role._id} value={role._id}>
              {role.roleName}
            </option>
          ))}
        </select>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Adding..." : "Add Staff"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddStaffModal;
